
/* Карточки-перевертыши flip-cards */
if ($('.js-flip-icon').length) {

    $('.js-flip-icon').on('click', function (e) {
        let $currWrap = $(this).closest('.js-flip-wrapper');

        if ($currWrap.is('[data-not-hover-flip]')) {
            $currWrap.toggleClass('_hover');
        }

        e.preventDefault();
    });

    /* Если мобильный, то при клике сморим нажали на иконку или нет */
    if (App.mobile) {
        App.H.on('click', '.js-flip-wrapper', function (e) {
            if (!$(this).is('[data-not-hover-flip]')) {
                if ($(e.target).hasClass('js-flip-icon')) {
                    $(this).toggleClass('_hover');
                } /*else if (!$(this).hasClass('_hover')) {
                 $(this).toggleClass('_hover');
                 }*/ else if ($(e.target).closest('a[href]').length) {
                    window.location.href = $(e.target).closest('a[href]').attr('href');
                }
            }

            e.preventDefault();
        });
    } else {
        App.H.on('mouseenter', '.js-flip-wrapper', function () {
            let $currFlipWrap = $(this);

            if (!$currFlipWrap.is('[data-not-hover-flip]')) {
                $currFlipWrap.toggleClass('_hover');
            }
        });

        App.H.on('mouseleave', '.js-flip-wrapper', function () {
            let $currFlipWrap = $(this);

            if (!$currFlipWrap.is('[data-not-hover-flip]')) {
                $currFlipWrap.toggleClass('_hover');
            }
        });
    }
}
